import React from 'react';
import { useTranslations } from '@lang';
import AddAnother from '@common/features/AddAnother';
import { EntityTypes } from '@common-types/Entities';
import { Container, Title } from './UpsellPrompts.styles';

const UpsellPromptsContainer: React.FC<{}> = () => {
  const { t } = useTranslations();
  return (
    <>
      <Title>{t('basket.addToYourOrder')}</Title>
      <Container>
        <AddAnother type={EntityTypes.ROOM} />
        <AddAnother type={EntityTypes.TABLE} />
        <AddAnother type={EntityTypes.SPA_DAY} />
        <AddAnother type={EntityTypes.TREATMENT} />
        <AddAnother type={EntityTypes.SPA_CLASS} />
        <AddAnother type={EntityTypes.FACILITY} />
        <AddAnother type={EntityTypes.PRODUCT} />
      </Container>
    </>
  );
};

export default UpsellPromptsContainer;
